import { render, staticRenderFns } from "./RecordPage.vue?vue&type=template&id=2a0cc27a&scoped=true&"
import script from "./RecordPage.vue?vue&type=script&lang=js&"
export * from "./RecordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0cc27a",
  null
  
)

export default component.exports